export default __webpack_public_path__ + "static/media/logo.8042d99d.svg";